export default "__VITE_ASSET__9080176f__"